// Auth helper sederhana — localStorage based
// Todo: upgrade ke proper auth (JWT/Session) saat M07

export function getCurrentUserId(): string | null {
  return localStorage.getItem("fotomomen_userId");
}

export function setCurrentUserId(userId: string) {
  localStorage.setItem("fotomomen_userId", userId);
}

export function clearCurrentUserId() {
  localStorage.removeItem("fotomomen_userId");
}

export function isHost(): boolean {
  const role = localStorage.getItem("fotomomen_userRole");
  return role === "host";
}